import { array, number, object, string } from "superstruct";

import TikTokPostTagSchema from "./TikTokPostTagSchema";

const TikTokPostSchema = object({
    postId: string(),
    postUrl: string(),
    title: string(),
    embed: string(),
    thumbnailUrl: string(),
    position: number(),
    tags: array(TikTokPostTagSchema),
});

export default TikTokPostSchema;
